import { queryClient, useMutation } from '../../../../ReactQuery';
import { post } from '../../../../redux/api';
import type { FullTeamGroupResponse, TeamGroupTeamsRequest } from '../../../../../shared/types/routes/teamGroups';

import { getTeamGroupQueryKey } from './useTeamGroup';
//  Function to add teams to a team group
function createTeamGroupTeams(
  teamGroupTeams: TeamGroupTeamsRequest,
  teamGroupId: number,
): Promise<FullTeamGroupResponse> {
  return post<TeamGroupTeamsRequest, FullTeamGroupResponse>(`/api/teams/groups/${teamGroupId}/teams`, teamGroupTeams).then(response => {
    if (!response.data) {
      throw new Error('No data returned from the server');
    }
    return response.data; // Return the team group so the onSuccess can update the cache
  });
}

/**
 * useCreateTeamGroupTeams is a hook that adds teams to a team group and invalidates the team groups query.
 */
export default function useCreateTeamGroupTeams(teamGroupTeams: TeamGroupTeamsRequest, teamGroupId: number) {
  return useMutation({
    mutationFn: () => createTeamGroupTeams(teamGroupTeams, teamGroupId),
    onSuccess: (data: FullTeamGroupResponse) => {
      // Update the cache
      queryClient.setQueryData(
        getTeamGroupQueryKey(teamGroupId),
        (oldTeamGroup?: FullTeamGroupResponse) => {
          if (!oldTeamGroup) {
            return undefined;
          }
          return data;
        },
      );
    },
  });
}
